import Script from 'next/script';
import getConfig from 'next/config';

// 이니시스 결제창 Close 스크립트를 위한 페이지
export default function PaymentClosePage() {
  const { publicRuntimeConfig } = getConfig();
  return <Script src={`${publicRuntimeConfig.inicisPCBaseURL}/stdjs/INIStdPay_close.js`} strategy="beforeInteractive" />;
}
